// @flow
import type {Accessory} from 'data/reservations/types';

export const mapPreselectedAccessories = (accessories: Accessory[]): Accessory[] =>
  accessories && accessories.filter(accessory => accessory.preselect);
